import { Breadcrumbs, Stack, useParsedSearchParams } from "@fidelix/fx-miranda";
import styled from "styled-components";
import { GraphicsHeaderButtons } from "./graphics-header-buttons";
import { HasPermission } from "../utils/permission-helper";
import { Permissions } from "../const";
export function GraphicsHeader() {
  const { parsedParams } = useParsedSearchParams({
    path: {
      parse: (params) => JSON.parse(params.get("path") ?? "[]") as string[],
      defaultValue: undefined,
    },
  });
  if (parsedParams.path.length === 0) {
    return null;
  }
  return (
    <Header>
      <Stack justify={"space-between"}>
        <Breadcrumbs>
          {parsedParams.path.map((item, index) => (
            <Breadcrumbs.Item key={index}>{item}</Breadcrumbs.Item>
          ))}
        </Breadcrumbs>
        <Stack justify={"space-between"}>
          <HasPermission permission={Permissions.HISTORY_VIEW}>
            <GraphicsHeaderButtons />
          </HasPermission>
        </Stack>
      </Stack>
    </Header>
  );
}

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.space("large")};
  padding-bottom: ${(p) => p.theme.space("small")};
  border-bottom: 1px solid ${(p) => p.theme.colors.lightNeutral};
`;
